import { type FC } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { inAppChatService } from '@egw/app-chat'
import { Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { sendEvent } from '@egw/events'
import { Layout, PageHeader } from '../../../components'

export const RecoveryProblemPage: FC = () => {
  const { t } = useTranslation('features-auth')
  const { searchParams } = useRouter()

  // const { inAppChatOpen } = inAppChatService

  const getTitle = (): string => {
    switch (searchParams().get('reason')) {
      case 'expired':
        return t('recovery.problem_title_expired')
      case 'failed':
        return t('recovery.problem_title_failed')
      default:
        return t('recovery.problem_title')
    }
  }

  return (
    <Layout>
      <PageHeader title={getTitle()} />
      <p className="mb-2 text-left text-red-700 flex flex-row">
        <ExclamationCircleIcon width={16} className="text-red-500 mr-2" />
        {t('recovery.problem_title')}
      </p>
      <p className="text-left text-body">{t('recovery.problem_description')}</p>
      <div className="flex-1 md:hidden" />
      <Button
        testId="recoveryProblem_primary_btn"
        className="mt-2 w-full md:w-max md:mt-8 mb-6"
        onClick={() => {
          sendEvent('user_clientServiceContact_click', {
            eventSource: 'egWealth',
            category: 'passkey-recovery',
            subCategory: 'intent',
          })
          inAppChatService.open()
        }}
      >
        {t('recovery.problem_button')}
      </Button>
    </Layout>
  )
}
